import mentorshipHome from "@/views/mentorship/mentorshipHome.vue";
import structureGovernance from "@/views/mentorship/StructureGovernance/structureGovernance.vue";



export default [
    {
        path: "/mentorship",
        redirect: "/mentorship/mentorshipHome",
        children: [
            {
                path: 'mentorshipHome',
                name: 'mentorshipHome',
                component: () => import('@/views/mentorship/mentorshipHome.vue')
            },
            {
                path: 'structureGovernance',
                name: 'structureGovernance',
                component: () => import('@/views/mentorship/StructureGovernance/structureGovernance.vue')
            },
            {
                path: 'skillsTechnology',
                name: 'skillsTechnology',
                component: () => import('@/views/mentorship/skillsTechnology/skillsTechnology.vue')
            },
            {
                path: 'skillsDetails/:uniqueId',
                name: 'skillsDetails',
                component: () => import('@/views/mentorship/skillsTechnology/skillsDetails.vue')
            },
            {
                path: 'technologies/:uniqueId',
                name: 'technologies',
                component: () => import('@/views/mentorship/skillsTechnology/technologies.vue')
            },
            {
                path: 'cadreEvaluation/:uniqueId',
                name: 'cadreEvaluation',
                component: () => import('@/views/mentorship/mentorshipEvaluation/cadreEvaluation.vue')
            },
            {
                path: 'generalMetricsList/:uniqueId',
                name: 'generalMetricsList',
                component: () => import('@/views/mentorship/mentorshipEvaluation/generalMetricsList.vue')
            },
            {
                path: 'cadreMetricsList/:uniqueId',
                name: 'cadreMetricsList',
                component: () => import('@/views/mentorship/mentorshipEvaluation/cadreMetricsList.vue')
            },
            {
                path: 'mentorshipEvaluation',
                name: 'mentorshipEvaluation',
                component: () => import('@/views/mentorship/mentorshipEvaluation/mentorshipEvaluation.vue')
            },
            {
                path: 'cardeSkillsTechnology',
                name: 'cardeSkillsTechnology',
                component: () => import('@/views/mentorship/cardeSkillsTechnology/cardeSkillsList.vue')
            },
            
        ]
    },
    {
        path: 'mentorProgramDoc',
        name: 'MentorshipProgramDoc',
        component: () => import('@/views/mentorship/MentorshipProgramDoc.vue'),
    },
];
